import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { PageSection } from '@openx/components-core/lib/PageSection/PageSection.tsx';
import { RIGHT_COLUMN_WIDTH } from '@openx/constants/form.ts';
import type { SynchronizedWith } from '@openx/types/deal.ts';
import { useTranslation } from 'react-i18next';
import { useDealContext } from '../../utils/context/DealContext.tsx';
import { SyncStatusField } from '../components/SyncStatusField.tsx';

type AmazonSyncStatusSectionProps = {
  amazonSync: NonNullable<SynchronizedWith['amazon_sync']>;
};

export const AmazonSyncStatusSection = ({ amazonSync }: AmazonSyncStatusSectionProps) => {
  const { t } = useTranslation();
  const { useAmazonSyncStatusOptionsFetch } = useDealContext();
  const { loading: syncStatusLoading, mapById: syncStatusMapById } = useAmazonSyncStatusOptionsFetch();

  const syncStatus = amazonSync.amazon_sync_status
    ? (syncStatusMapById[amazonSync.amazon_sync_status]?.name ?? amazonSync.amazon_sync_status)
    : amazonSync.amazon_sync_status;

  const syncStatusTooltip = amazonSync.amazon_sync_status
    ? (syncStatusMapById[amazonSync.amazon_sync_status]?.description ?? undefined)
    : undefined;

  return (
    <PageSection title={t('Status')} dataTest="status-section" divider>
      <Grid container spacing={3} size={RIGHT_COLUMN_WIDTH + 1}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <SyncStatusField
            label={t('Synchronization Status')}
            loading={syncStatusLoading}
            status={amazonSync.amazon_sync_status}
            statusLabel={syncStatus}
            tooltip={syncStatusTooltip}
            lastErrorDatetime={amazonSync.amazon_last_sync_error?.last_error_datetime}
          />
        </Box>
      </Grid>
    </PageSection>
  );
};
